export default __webpack_public_path__ + "static/media/Icon-two.18a24063.svg";